// Плашка о cookies: показывается один раз, пока пользователь не нажмёт «Понятно» (флаг в localStorage).
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { COLORS } from '../theme/tokens';

export default function CookieNotice() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem('airun_cookie_ok')) setShow(true); } catch {}
  }, []);
  if (!show) return null;
  const accept = () => {
    try { localStorage.setItem('airun_cookie_ok', '1'); } catch {}
    setShow(false);
  };
  return (
    <Box sx={{
      position: 'fixed', bottom: 16, left: 16, right: { xs: 16, sm: 'auto' }, maxWidth: { sm: 360 },
      bgcolor: '#fff', border: `1px solid ${COLORS.cardBorder}`, borderRadius: 3,
      boxShadow: '0 8px 30px rgba(0,0,0,0.12)', zIndex: 1400, p: 2,
      display: 'flex', alignItems: 'center', gap: 1.5,
    }}>
      <Typography sx={{ fontSize: '0.85rem', color: COLORS.body, lineHeight: 1.4 }}>
        Мы используем cookies для работы сайта и аналитики.{' '}
        <a href="/policy.html" target="_blank" rel="noopener noreferrer" style={{ color: '#667eea' }}>Подробнее</a>
      </Typography>
      <Button size="small" onClick={accept} sx={{
        flexShrink: 0, textTransform: 'none', fontWeight: 600, color: '#fff', borderRadius: 2, px: 2,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        '&:hover': { background: 'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)' },
      }}>Понятно</Button>
    </Box>
  );
}
